import type { SearchQuery } from "@nosto/nosto-js/client"

/**
 * Stable identity for "same SERP result set" ignoring raw pagination offsets.
 * Used to avoid redundant Nosto round-trips when only the URL page changes.
 */
export function searchQuerySignature(query: SearchQuery): string {
  const products = query.products
  if (!products) {
    return JSON.stringify({ query: query.query, products: undefined })
  }

  const productRest = { ...products }
  delete productRest.from
  return JSON.stringify({
    query: query.query,
    products: productRest
  })
}
